import { LandingMediaDropbox } from './MediaDropBox';
import { FieldTitle } from './RedStarTitle';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from '@client/new/components/basic';
import { FieldDesc } from './common';
import { SelectImageSideInput } from './SelectImageSide';
import { TwoColumns } from './layouts';

type Props = {
  imageUpload: (file: File) => Promise<string>;
  index: number;
};
export function BioSection({ imageUpload, index }: Props) {
  const { register, control } = useFormContext();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const r = (s: any) => register(`sections.${index}.${s}`);

  const firstCol = (
    <>
      <div>
        <FieldTitle title={'Headline text'} />
        <FieldDesc>
          The headline is used to communicate the creator’s value proposition in
          the hero section of the sales page.
        </FieldDesc>
        <div className="max-w-[680px]">
          <TextField
            {...r(`title`)}
            className="mb-[5px] max-w-[680px] w-full"
            inputProps={{
              placeholder: 'Headline text',
              maxLength: 60,
            }}
          />
        </div>
      </div>
      <div>
        <FieldTitle title={'Description'} />
        <FieldDesc>
          Description (new lines are preserved, max 3000 characters)
        </FieldDesc>
        <div className="max-w-[680px] w-full">
          <TextField
            {...r(`desc`)}
            multiline
            rows={5}
            className="mb-[5px] w-full"
            inputProps={{
              placeholder: 'Description',
              maxLength: 3000,
            }}
          />
        </div>
      </div>
    </>
  );

  const secondCol = (
    <>
      <Controller
        name={`sections.${index}.coverImage`}
        control={control}
        render={({
          field: { value, onChange, ref },
          fieldState: { error },
        }) => (
          <LandingMediaDropbox
            inputRef={ref}
            upload={imageUpload}
            label="Profile Image"
            validationText="Image displayed in Bio section"
            value={value}
            onChange={onChange}
            type="image"
            icon={faImage}
            errorMsg={error?.message}
          >
            <ul className="text-black list-none text-center text-h12">
              <li>Square image/gif, max 5MB</li>
            </ul>
          </LandingMediaDropbox>
        )}
      />
      <div>
        <SelectImageSideInput index={index} defaultSide="left" />
      </div>
    </>
  );
  return <TwoColumns first={firstCol} second={secondCol} />;
}
